// extracted by mini-css-extract-plugin
module.exports = {"label":"Collapsible_label__107z0"};